const proxyKeydownToParentContext = (event) => {
  const { frameElement } = event.target.ownerDocument.defaultView;

  const keydownEvent = new KeyboardEvent('keydown', {
    bubbles: true,
    cancelable: true,
    key: event.key,
    keyCode: event.keyCode,
    code: event.code,
    ctrlKey: event.ctrlKey,
    altKey: event.altKey,
    metaKey: event.metaKey,
    shiftKey: event.shiftKey,
    view: window,
  });

  // eslint-disable-next-line no-underscore-dangle
  keydownEvent.__detail = {
    contentEditable: Boolean(event.srcElement && event.srcElement.hasAttribute('contenteditable')),
  };

  frameElement.dispatchEvent(keydownEvent);
};

export default proxyKeydownToParentContext;
